module.exports = __webpack_public_path__ + "img/CarouselOfFloorplans.311f8c62.png";